module.exports = __webpack_public_path__ + "assets/img/mecha-btn-e542447e.png";